import React, { useState, useEffect } from "react";
import moment from "moment";
import { Line, Bar } from "react-chartjs-2";
import FETCH from "../../../utils/fetch";
import "../LiabilityDashboard.css";
import debtImage from "../../../assets/images/debt.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { ChartColors } from "../../../components/ChartColors";
import getFAClientName from "../../../helpers/getFAClientName";
import { Spin } from "antd";
export const LiabilityReport = (props) => {
  const [monthlyPayment, setMonthlyPayment] = useState([]);
  const [clientName, setClientName] = useState("");

  const dataToUse =
    props.allLiabilitiesForChart && props.allLiabilitiesForChart.length > 0
      ? props.allLiabilitiesForChart
      : props.liabilitiesCredit || [];

  const uniqueModules = [
    ...new Set(
      dataToUse.map(
        (data) => data["Nickname of Liabilities"] || data["Nickname of Credit"]
      )
    ),
  ];
  const nicknames = dataToUse.map(
    (card) =>
      card["Nickname of Liabilities"] || card["Nickname of Credit"] || null
  );

  // const data = props.liabilitiesCredit && props.liabilitiesCredit.map(data => {
  //   const initialLoanAmount = +data["Initial Loan Amount"] || 0;
  //   const creditBalance = +data["Credit Balance"] || 0;
  //   return initialLoanAmount || creditBalance || 0;
  // });
  // const uniqueModules = [
  //   ...new Set(
  //     (props.liabilitiesCredit || []).filter(data => data.subType === "Liability").map(
  //       data => data["Nickname of Liabilities"] || null
  //     )
  //   )
  // ];
  const valueTotal = dataToUse.reduce(
    (sum, item) => sum + (item["Monthly Payment"] || 0),
    0
  );

  useEffect(() => {
    const barSeries = [
      {
        label: "Module",
        data:
          dataToUse &&
          dataToUse.map(
            (data) =>
              +data["Loan Balance"] ||
              +data["Initial Loan Amount"] ||
              0 ||
              +data["Credit Balance"] ||
              0 ||
              0
          ),
        fill: false,
        backgroundColor:
          dataToUse &&
          dataToUse.map(
            (_, index) => ChartColors[index % ChartColors.length]
          ),
        borderColor:
          dataToUse &&
          dataToUse.map(
            (_, index) => ChartColors[index % ChartColors.length]
          ),
      },
    ];
    console.log("series2 bar", barSeries);
    setMonthlyPayment(barSeries);
  }, [props.liabilitiesCredit, props.allLiabilitiesForChart]);

  console.log("logo uniqueModules", monthlyPayment, uniqueModules);
  const data2 = {
    labels: nicknames && nicknames,
    // labels: ["All Modules"],
    datasets: monthlyPayment && monthlyPayment,
  };

  useEffect(() => {
    const name = getFAClientName();
    if (name) setClientName(name);
  }, [])

  return (
    <React.Fragment>
      <div className="liabiltyCard1">
        <h3 className="Reportheading">Liabilities and Credit Report</h3>
        <div className="liabilityRow">
          <div className="liliability-image-and-amount-container">
            <img src={debtImage} alt="" />
            <div className="liliability-amounts-container">
              <div style={{ display: "flex", gap: "2rem" }}>
                <div>
                  <h3>Loans</h3>
                  <h2>
                    $
                    {props.totalLoan &&
                      parseFloat(props.totalLoan)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </h2>
                </div>
                <div>
                  <h3>Credit Cards/HELOC</h3>
                  <h2>
                    $
                    {props.totalBalance &&
                      parseFloat(props.totalBalance)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </h2>
                </div>
              </div>
              <div>
                <h1>Total</h1>
                <h1>
                  $
                  {((parseFloat(props.totalLoan) || 0) + (parseFloat(props.totalBalance) || 0))
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </h1>

                {/*<h1>${props.totalBalance && props.totalLoan && (props.totalBalance+props.totalLoan).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h1>*/}
              </div>
            </div>
          </div>
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                  {clientName || localStorage.getItem("User") || ""}
                </span>
              </div>
            </div>
            <div className="reportrow2">
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="liabiltyCard2" style={{ position: "relative" }}>
        <h1 className="liablitycardheading">Balance</h1>
        <div style={{ marginTop: "1rem", display: "flex", flexGrow: "1" }}>
          {props.loadingLiabilityChartData ? (
            <div
              style={{
                display: "flex",
                flexGrow: "1",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px",
                width: "100%",
              }}
            >
              <Spin size="large" />
            </div>
          ) : nicknames && nicknames.length > 0 ? (
            <div style={{ width: "100%", height: "300px" }}>
              <Bar
                data={data2}
                height={300}
                options={{
                  legend: {
                    display: false,
                  },
                  tooltips: {
                    callbacks: {
                      label: function (tooltipItem, chartData) {
                        const datasetLabel =
                          chartData.datasets[tooltipItem.datasetIndex].label ||
                          "";
                        const value = tooltipItem.yLabel;
                        const formattedValue = new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                        return `${datasetLabel}: ${formattedValue}`;
                      },
                    },
                  },
                  maintainAspectRatio: false,
                  responsive: true,
                  scales: {
                    xAxes: [
                      {
                        gridLines: {
                          color: "rgba(0, 0, 0, 0)",
                        },
                      },
                    ],
                    yAxes: [
                      {
                        ticks: {
                          callback: function (value) {
                            return new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(value);
                          },
                        },
                      },
                    ],
                  },
                }}
              />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexGrow: "1",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px",
                width: "100%",
              }}
            >
              No Data to show
            </div>
          )}
        </div>
        <NewLoader isLoading={props.loading} />
      </div>
    </React.Fragment>
  );
};
